export enum AttributeClassificationTypes {
    PII = "PII",
    DEVICES = "Devices",
    PREFERENCES = "Preferences",
    ORGANIZATION = "Organization",
    OTHER = "Other",
    ACQUIRED = "Acquired",
    GOVERNMENT_ISSUED = "GovernmentIssued",
    THIRD_PARTY_SCORE = "ThirdPartyScore",
    CUSTOM = "Custom"
}

export enum AttributeClassificationTypeIds {
    PII = "1",
    DEVICES = "2",
    PREFERENCES = "3",
    ORGANIZATION = "4",
    OTHER = "5",
    ACQUIRED = "6",
    GOVERNMENT_ISSUED = "7",
    THIRD_PARTY_SCORE = "8",
    CUSTOM = "9"
}